import { ReactNode } from "react";

import ExternalLink from "~/components/ExternalLink";
import { DOCUMENTATION_ATTR_LINK } from "~/const";
import { useTrans } from "~/hooks/useTrans";
import WhatAbout from "../WhatAbout";
import { getCatalogLink } from "~/utils/utils";

export type TVariant = "option1" | "option2" | "option3" | "option5";

interface IBetterTariffSpecificationContent {
	variant: TVariant;
	lang: string;
}

export default function BetterTariffSpecificationContent({
	variant,
	lang,
}: IBetterTariffSpecificationContent) {
	const { trans } = useTrans();
	const opts: any = {};
	let children: ReactNode = null;

	switch (variant) {
		case "option2":
			opts.dangerouslySetInnerHTML = { __html: trans("betterTariffRequestModal.option2.desc", { br: "<br /><br />" }) };
			break;

		case "option3":
			children = <>
				{ trans("betterTariffRequestModal.option3.desc") }
				&nbsp;
				<ExternalLink to={DOCUMENTATION_ATTR_LINK} sx={{ fontSize: "var(--default-font-size)" }}>
					{ trans("projectsPage.motivation.documentation") }
				</ExternalLink>.
			</>;
			break;

		case "option5":
			children = <>
				<span dangerouslySetInnerHTML={{ __html: trans("betterTariffRequestModal.option5.desc", { br: "<br /><br />" }) }} />
				&nbsp;
				<span className="margin-top-large" style={{ display: "block" }}>
					<WhatAbout title={ trans("projectCatalogPage.whatAbout") } link={getCatalogLink(lang)} />
				</span>
			</>;
			break;

		default:
			opts.dangerouslySetInnerHTML = { __html: trans("betterTariffRequestModal.option1.desc", { br: "<br /><br />" }) };
	}

	return <p { ...opts }>
		{ children }
	</p>;
}
